module.exports = "<p-panel header=\"Additional info\">\n  <p>You have 0 unread messages since your last login</p>\n</p-panel>\n"